import './init';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './app.scss';
import '@mantine/dates/styles.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import '@mantine/dropzone/styles.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import '@mantine/carousel/styles.css';

import { BrowserRouter } from 'react-router';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { AppRoutes } from './routes';
import { theme } from './theme';

export default function App() {
  return (
    <MantineProvider theme={theme}>
      <Notifications />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </MantineProvider>
  );
}
